import React, { useState, useRef } from "react";
import classes from "./PhotosAndVideosMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Button } from "../../../../../stories/Button/Button";
import { ImageAndVideoBoxWithDeleteBtn } from "../../../../../stories/ImageAndVideoBoxWithDeleteBtn/ImageAndVideoBoxWithDeleteBtn";
import {
  AddImageIcon,
  AddImageIconDisabled,
  cancelIcon,
} from "../../../../../constant/imagePath";
import { useHistory } from "react-router-dom";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../../store/Actions/commonAction";

const PhotosAndVideosMobile = () => {
  const history = useHistory();
  const imageRef = useRef();
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] +
      " " +
      activeTab.split("-")[1] +
      " " +
      activeTab.split("-")[2]
    : activeTab;
  return (
    <div className={[classes.PhotosAndVideosScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Edit Profile
        </p>
      </div>

      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col sm={12}>
            <Col sm={12} className={[classes.mb32].join(" ")}>
              <Tabs
                tabsData={[
                  { label: "Personal info", activeText: "personal info" },
                  { label: "Photo & video", activeText: "photo and video" },
                  { label: "FAQ", activeText: "faq" },
                ]}
                state={{ label: convertedActiveTab }}
                setState={(item) => dispatch(setActiveTab(item?.activeText))}
                matchWithActiveText={true}
              />
            </Col>

            <Col sm={12} className={[classes.mb24].join(" ")}>
              <p
                className={[classes.mb24].join(" ")}
                style={{
                  ...Fonts.b1Mobile,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                You can upload a maximum of 8 photos or videos
              </p>
              <Button
                className={classes.addImageBtn}
                icon={AddImageIcon}
                label={"Add photo or video"}
                onClick={() => imageRef?.current?.click()}
                disabled={data?.length >= 8}
                disabledIcon={AddImageIconDisabled}
              />
              <input
                ref={imageRef}
                className="d-none"
                type="file"
                accept="video/*, image/*"
                multiple
                onChange={(e) => {
                  let newArr = data.slice();
                  newArr = [...newArr, ...e.target.files];
                  setData(newArr?.slice(0, 8));
                }}
                onClick={(event) => {
                  event.target.value = null;
                }}
              />
            </Col>

            <Col sm={12} className={[classes.mb24].join(" ")}>
              <h6 style={{ ...Fonts.h9 }}>
                Uploaded{" "}
                <span style={{ color: Colors.mainBlue }}>{data?.length}</span>{" "}
                of 8 files
              </h6>
            </Col>

            <Col sm={12} className={[classes.mb24].join(" ")}>
              <Row className={["gx-3"].join(" ")}>
                {data?.map((item, i) => {
                  return (
                    <Col xs={6} key={i} className={[classes.mb16].join(" ")}>
                      <ImageAndVideoBoxWithDeleteBtn
                        state={data}
                        setter={setData}
                        item={item}
                      />
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Col>
          <Col xs={12} style={{ alignSelf: "flex-end" }}>
            <Button
              customStyle={{ width: "100%", height: "56px" }}
              primary={true}
              size="Large"
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default PhotosAndVideosMobile;
